/* eslint-disable react-hooks/exhaustive-deps */
import React, { ChangeEvent, useEffect, useState, useRef } from "react";
import { ANALYTIC, ATTRIBUTE, CHOICES, COUNT, CUSTOM, DATA_CONFIGURATION, DEFAULT_VALUE, ENTER, ENTER_CHOICE, FIELD_CLASS, ITEM_IMAGE, LIST, MANAGE, MAX, MAX_COUNT, MAX_QUANTITY, MIN, MIN_COUNT, MIN_QUANTITY, NO_IMAGE_AVAILABLE, PREDICTIVE_SORT, QUANTITY, REQUIRED, SELECTION_TYPE, SELECT_CLASS, SYNC, VIEW_ON_LISTS,} from "../ISRConstants";
import { ClassIcon, DeleteIcon, ExternalLinkIcon, GearIcon, ImageIcon, ReloadIcon, XIcon,} from "assests/GmsIcons";
import { Data, TChoice, TField, TFieldDataConfiguration, TSubmodel, TConnector, TFieldClass, TProductCategory, TListItem, TUpsertISRProjectDataModelsInput, TIndexState, } from "../Pages/DefineModel/model";
import { getAllProjectClass, getAttributeValues,} from "../Pages/DefineModel/ModelServices/ModalServices";
import ToggleButton from "Components/Common/components/Inputs/ToggleButton";
import ManageClassDialog from "../Pages/DefineModel/Components/ManageClassDialog";
import { useISRContext } from "../Hooks/useISRContext";
import ConfigurationFilterComponent from "./ConfigurationFilterComponent";
import ConfigurationFilter from "./ConfigurationFilter";
import ItemImportDropdown from "../Pages/DefineModel/Components/ItemImportDropdown";
import { useHistory, useLocation } from "react-router-dom";
import { getListItem } from "Pages/GMS/List/Services/ListServices";

type TInputField = {
  id: number;
  value: string;
  choices: string;
};

type TMultiChoiceProps = {
  id: string;
  categoryTypeList: string[];
  categoryData: Data[];
  attributeData: Data[];
  listData: any[];
  projectId?: string;
  selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
  updateFieldDataConfiguration: Function;
  userProjectDataModels: TUpsertISRProjectDataModelsInput;
  indexInfo: TIndexState;

};

const MultiChoiceConfigurations = ({ id, listData, categoryData, attributeData, selectedItem, updateFieldDataConfiguration, projectId, userProjectDataModels, indexInfo }: TMultiChoiceProps) => {
  const [fieldDataConfiguration, setFieldDataConfiguration] = useState<TFieldDataConfiguration>({});
  const location = useLocation();
  const [inputFields, setInputFields] = useState<TInputField[]>([{ id: 1, value: "", choices: "" },]);
  const isrContext = useISRContext();
  const itemImportDropDownRef = useRef<any>(null)
  const [showClassMenu, setShowClassMenu] = useState<boolean>(false);
  const [showImage, setShowImage] = useState<boolean>(false);
  const [imageUrl, setImageUrl] = useState<string>("");
  const [selectedFilter, setSelectedFilter] = useState<string>(CUSTOM);
  const [selectedId, setSelectedId] = useState<string | undefined>("");

  const isGuide = Boolean(location.pathname.includes('/guide/'));

  // Define state for current page
  const [currentPage, setCurrentPage] = useState(1);
  const [visiblePages, setVisiblePages] = useState<number[]>([]);

  // Define state for loaded data
  const [loadedData, setLoadedData] = useState<TChoice[] | TListItem[]>([]);
  const openConnectorMenu = () => setShowClassMenu(true);

  const history = useHistory();
  const listsOptions = listData?.map((x) => {
    return { label: x?.name, value: x?.id };
  });
  const attributeOptions = attributeData?.map((x: any) => {
    return { label: x?.name, value: x?.id };
  });

  useEffect(() => {
    itemImportDropDownRef?.current?.clearSearchTerm();
    setSelectedId("");
    setFieldDataConfiguration({});
    const existingValue =
      selectedItem &&
      "dataConfiguration" in selectedItem &&
      selectedItem?.dataConfiguration
        ? selectedItem.dataConfiguration
        : {};
    setFieldDataConfiguration(existingValue);
    setSelectedFilter(existingValue?.propType ?? CUSTOM);
    setSelectedId(existingValue?.id);
  }, [selectedItem]);

  useEffect(() => {
    if(fieldDataConfiguration?.id){
      setSelectedId(fieldDataConfiguration?.id);
      if (
        !fieldDataConfiguration?.choices ||
        fieldDataConfiguration?.choices.length === 0
      ) {
        fieldDataConfiguration?.propType === LIST
          ? fetchListValues(fieldDataConfiguration?.id)
          : fetchAttributeValues(fieldDataConfiguration?.id);
      }
    }
  }, [fieldDataConfiguration?.id]);

  useEffect(() => {
    updateFieldDataConfiguration(fieldDataConfiguration);
  }, [fieldDataConfiguration]);

  useEffect(() => {
    fetchAllClasses();
  }, []);

  useEffect(() => {
    setVisiblePagesHandler();
    console.log("ASSD", selectedFilter)
  }, [selectedFilter, fieldDataConfiguration?.choices]);

  const customOptions: any = [];
  // const [selectedCustom, setSelectedCustom] = useState<string>("");

  const handleDeleteField = (attributeValues: any, index: number) => {
    console.log(attributeValues);
    // av_id
    const updatedChoices = [...(fieldDataConfiguration?.choices || [])].filter(obj => obj.av_id !== attributeValues.av_id);
    // updatedChoices.splice(index, 1);
    setFieldDataConfiguration((prevConfig) => ({
      ...prevConfig,
      choices: updatedChoices,
    }));
  };

  const handleInputChange = (
    index: number,
    inputValue: string,
    propertyName: string
  ) => {
    const updatedInputFields = [...inputFields];
    updatedInputFields[index] = {
      ...updatedInputFields[index],
      [propertyName]: inputValue,
    };
    setInputFields(updatedInputFields);
  };

  const fetchAttributeValues = async (attributeId: string) => {
    try {
      const responseData = await getAttributeValues(attributeId);
      if (responseData?.done) {
        const newChoices = responseData?.data?.map(
          (c: any) => {
            return {
              ...c,
              display_value: c?.av_value,
            };
          }
        );
        updateChoices(attributeId, ATTRIBUTE, newChoices);
      } else {
        updateChoices(attributeId, ATTRIBUTE, []);
      }
    } catch (error) {
      updateChoices(attributeId, ATTRIBUTE, []);
      console.log(error, "Error");
    }
  };

  const fetchListValues = async (listId: string) => {
    try {
      const responseData = await getListItem(listId);
      if (!responseData?.errorfound) {
        const newChoices = responseData?.data?.data?.items?.filter(
          (x: TListItem) => x.visibility
        )?.map(
          (c: TListItem) => {
            return {
              av_id: c?.title,
              av_value: c?.title,
              display_value: c?.display_value,
              product_image: c?.image,
              visibility: c?.visibility,
              helpText: c?.helpText,
              math_value: c?.math_value,
            };
          }
        );
        updateChoices(listId, LIST, newChoices);
      } else {
        updateChoices(listId, LIST,  []);
      }
    } catch (error) {
      updateChoices(listId, LIST,  []);
      console.log(error, "Error");
    }
  };

  const updateChoices = (id: string, type: string, newChoices: TChoice[] | undefined) => {
    const updatedFieldDataConfiguration = { ...fieldDataConfiguration };
    updatedFieldDataConfiguration.id = id;
    updatedFieldDataConfiguration.propType = type;
    updatedFieldDataConfiguration.choices = Array.isArray(newChoices)
      ? newChoices
      : [];
    setFieldDataConfiguration(updatedFieldDataConfiguration);
  };

  const handleSelectTypeChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const updatedFieldDataConfiguration = { ...fieldDataConfiguration };
    updatedFieldDataConfiguration.selectType = !!event.target.value ? event.target.value : undefined;
    setFieldDataConfiguration(updatedFieldDataConfiguration);
  };

  const handleDefaultTypeChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const updatedFieldDataConfiguration = { ...fieldDataConfiguration };
    updatedFieldDataConfiguration.defaultValue = !!event.target.value ? event.target.value : undefined;
    setFieldDataConfiguration(updatedFieldDataConfiguration);
  };

  const handleRequiredChange = (value: boolean) => {
    setFieldDataConfiguration((prevConfig) => ({...prevConfig, fieldRequired: value}));
  }

  const handlePredictiveSortChange = (value: boolean) => {
    setFieldDataConfiguration((prevConfig) => ({
      ...prevConfig,
      predictiveSort: value,
    }));
  };

  const handleClassChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    const selectedObject = isrContext?.fieldClasses?.find(
      (item: TFieldClass) => item.name === selectedValue
    );
    setFieldDataConfiguration((prevConfig) => ({
      ...prevConfig,
      class: selectedObject,
    }));
  };

  const fetchAllClasses = async () => {
    try {
      const responseData = await getAllProjectClass(projectId ?? "");
      if (responseData?.done) {
        isrContext?.setFieldClasses(responseData?.data?.fieldClasses ?? []);
        isrContext?.setModelClasses(responseData?.data?.modelClasses ?? []);
      } else {
        //toast.error(responseData?.message);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  // Assuming you have the following constants
  const ITEMS_PER_PAGE = 10;
  const VISIBLE_PAGES = 10;

  // Function to handle page change
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const setVisiblePagesHandler = () => {
    if (fieldDataConfiguration?.choices) {
      setLoadedData(fieldDataConfiguration.choices);
      setVisiblePages(
        getVisiblePageRange(
          1,
          Math.ceil(fieldDataConfiguration?.choices.length / ITEMS_PER_PAGE)
        )
      );
    }
  };

  // Calculate the index range for the current page
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;

  // Function to get the visible page range
  const getVisiblePageRange = (currentPage: number, totalPages: number) => {
    const middle = Math.floor(VISIBLE_PAGES / 2);
    let start = currentPage - middle;
    let end = currentPage + middle;

    if (start <= 0) {
      start = 1;
      end = Math.min(totalPages, VISIBLE_PAGES);
    }

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - VISIBLE_PAGES + 1);
    }

    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };

  const handleMinMaxFields = (value: number, property: string) => {
    setFieldDataConfiguration((prevConfig) => {
      if (!prevConfig) return prevConfig;
      const updatedData = {
        ...prevConfig,
        [property]: value,
      };
      return updatedData;
    });
  };

  return (
    <div id={id} className="cart-style-dm">
      <div className="tw-flex tw-justify-between tw-items-center ">
        <label className="cart-title">{DATA_CONFIGURATION}</label>
        <div className="tw-flex tw-flex-wrap tw-items-center">
          <ConfigurationFilter
            id={`${id}-filter`}
            labels={[CUSTOM, ATTRIBUTE, LIST]}
            selectedFilter={selectedFilter ?? ""}
            setSelectedFilter={setSelectedFilter}
          />
        </div>
      </div>
      <div>
        <div className="tw-w-full tw-h-9 tw-mb-2 tw-left-0">
          {selectedFilter.toLocaleLowerCase() === "custom" && (
            <div className="tw-flex tw-justify-between">
              <div className="tw-w-[30%]">
                <ItemImportDropdown
                  id={`${id}-class-dropdown`}
                  onChange={(e: string) => {
                    setSelectedId(e);
                    fetchListValues(e);
                  }}
                  value={""}
                  options={customOptions}
                  name={`Select ${selectedFilter}`}
                  disabled={true}
                  isSearchable
                />
              </div>
              <button onClick={() => {}} className="tw-p-2 tw-text-blue-700">
                <span className="tw-flex tw-justify-center tw-place-content-center">
                  <div className="tw-p-1.5">
                    <ReloadIcon />
                  </div>
                  {SYNC}
                </span>
              </button>{" "}
            </div>
          )}
          {selectedFilter.toLocaleLowerCase() === ATTRIBUTE && (
            <div className="tw-flex tw-justify-between">
              <div className="tw-w-[30%]">
                <ItemImportDropdown
                  id={`${id}-attribute-dropdown`}
                  onChange={(e: string) => {
                    setSelectedId(e);
                    fetchAttributeValues(e);
                  }}
                  value={selectedId ?? ""}
                  options={attributeOptions}
                  name={`Select ${selectedFilter}`}
                  disabled={false}
                  isSearchable
                />
              </div>
              <button
                onClick={() => {
                  fetchAttributeValues(fieldDataConfiguration?.id ?? "");
                }}
                className="tw-p-2 tw-text-blue-700"
              >
                <span className="tw-flex tw-justify-center tw-place-content-center">
                  <div className="tw-p-1.5">
                    <ReloadIcon />
                  </div>
                  {SYNC}
                </span>
              </button>{" "}
            </div>
          )}
          {selectedFilter.toLocaleLowerCase() === LIST && (
            <div className="tw-flex tw-justify-between">
              <div className="tw-w-[30%]">
                <ItemImportDropdown
                  id={`${id}-list-dropdown`}
                  onChange={(e: string) => {
                    setSelectedId(e);
                    fetchListValues(e);
                  }}
                  value={selectedId ?? ""}
                  options={listsOptions}
                  name={`Select ${selectedFilter}`}
                  disabled={false}
                  isSearchable
                />
              </div>
              {selectedId && fieldDataConfiguration?.propType?.toLowerCase()  == LIST && <button
                onClick={() => {
                  history.push(`/gms/taxonomy/lists/edit/${selectedId}`);
                }}
                className="tw-p-2 tw-text-blue-700 tw-ml-[40%]"
              >
                <span className="tw-flex">
                  <div className="tw-p-1.5">
                    <ExternalLinkIcon />
                  </div>
                  {VIEW_ON_LISTS}
                </span>
              </button>}
              <button
                onClick={() => {
                  fetchListValues(fieldDataConfiguration?.id ?? "");
                }}
                className="tw-p-2 tw-text-blue-700"
              >
                <span className="tw-flex tw-justify-center tw-place-content-center">
                  <div className="tw-p-1.5">
                    <ReloadIcon />
                  </div>
                  {SYNC}
                </span>
              </button>{" "}
            </div>
          )}
        </div>
      </div>

      {selectedFilter.toLowerCase() === ATTRIBUTE && fieldDataConfiguration?.propType?.toLowerCase()  == ATTRIBUTE && (
        <div>
          {fieldDataConfiguration?.choices &&
          fieldDataConfiguration?.choices.length !== 0 ? (
            <div className="tw-flex ">
              <div className="tw-label-header tw-w-[41%]">
                <label className="tw-text-sm tw-text-[#747593] tw-block">
                  {CHOICES}
                </label>
              </div>
            </div>
          ) : null}

          {fieldDataConfiguration?.choices &&
            fieldDataConfiguration?.choices.length !== 0 &&
            fieldDataConfiguration?.choices
              ?.slice(startIndex, endIndex)
              ?.map((attributeValues, index) => (
                <div
                  key={index}
                  className="tw-flex tw-items-center tw-w-full tw-gap-2 tw-mb-2"
                >
                  <div className="tw-w-[40%] ">
                    <div className="tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-auto tw-flex tw-flex-row tw-items-center tw-justify-start tw-py-2 tw-px-2.5 tw-mt-1 tw-gap-[10px] tw-text-sm tw-text-slategray tw-border-[1px] tw-border-solid tw-border-whitesmoke-200">
                      <input
                        value={
                          attributeValues?.value
                            ? attributeValues?.value
                            : attributeValues?.av_value
                        }
                        onChange={(e) =>
                          handleInputChange(index, e.target.value, "choices")
                        }
                        placeholder={ENTER_CHOICE}
                        className="tw-flex-1 tw-relative tw-text-black focus:tw-outline-none"
                      />
                    </div>
                  </div>
                  <div className="tw-w-auto tw-mt-2 tw-ms-1 ">
                    <button onClick={() => handleDeleteField(attributeValues, index)}>
                      <DeleteIcon />
                    </button>
                  </div>
                </div>
              ))}
        </div>
      )}

      {selectedFilter.toLowerCase() === LIST && fieldDataConfiguration?.propType?.toLowerCase()  === LIST && (
        <div className="tw-w-full">
          {fieldDataConfiguration?.choices &&
            fieldDataConfiguration?.choices.length !== 0 &&
            fieldDataConfiguration?.choices
              ?.slice(startIndex, endIndex)
              ?.map((item, index) => (
                <tr
                  key={index}
                  className={`tw-h-12 ${
                    index % 2 === 0 ? "tw-bg-white" : "tw-bg-gray-100"
                  } tw-pl-4 tw-pr-4  tw-h-12 tw-border tw-border-zinc-200`}
                >
                  <div
                    className={`tw-h-12 ${
                      index % 2 === 0 ? "tw-bg-white" : "tw-bg-gray-100"
                    } tw-pl-4 tw-pr-4 tw-w-[720px] tw-border tw-border-zinc-200 tw-flex tw-items-center tw-justify-center`}
                  >
                    <div
                      key={item?.av_id + index}
                      className="tw-flex tw-items-center tw-w-full tw-gap-2 tw-mb-2"
                    >
                      <div
                        onClick={() => {
                          setShowImage(true);
                          setImageUrl(item?.product_image);
                        }}
                      >
                        <ImageIcon />
                      </div>
                      <span className="tw-flex-1 tw-relative tw-text-black focus:tw-outline-none">
                        {item?.display_value ?? item?.av_value}
                      </span>
                    </div>
                  </div>
                </tr>
              ))}
        </div>
      )}

      {fieldDataConfiguration?.propType === selectedFilter ? fieldDataConfiguration?.choices &&
            fieldDataConfiguration?.choices.length !== 0 &&
            loadedData &&
            loadedData.length > ITEMS_PER_PAGE && (
              <div className="tw-flex tw-justify-center tw-mt-4">
                {currentPage > 1 && (
                  <button
                    onClick={() => {
                      handlePageChange(currentPage - 1);
                      setVisiblePages(
                        getVisiblePageRange(
                          currentPage - 1,
                          Math.ceil(loadedData.length / ITEMS_PER_PAGE)
                        )
                      );
                    }}
                  >
                    <span style={{ marginRight: "6px", color: "blue" }}>
                      {"< Previous"}
                    </span>
                  </button>
                )}
                {visiblePages.map((page) => (
                  <button key={page} onClick={() => handlePageChange(page)}>
                    <span style={{ marginRight: "6px", color: "blue" }}>
                      {page}
                    </span>
                  </button>
                ))}
                {currentPage <
                  Math.ceil(loadedData.length / ITEMS_PER_PAGE) && (
                  <button
                    onClick={() => {
                      handlePageChange(currentPage + 1);
                      setVisiblePages(
                        getVisiblePageRange(
                          currentPage + 1,
                          Math.ceil(loadedData.length / ITEMS_PER_PAGE)
                        )
                      );
                    }}
                  >
                    <span style={{ marginLeft: "6px", color: "blue" }}>
                      {"Next >"}
                    </span>
                  </button>
                )}
              </div>
            ):null}

      {fieldDataConfiguration?.choices &&
        fieldDataConfiguration?.choices.length === 0 && (
          <div className="tw-w-[752px] tw-h-12 tw-bg-gray-100 tw-rounded tw-border tw-text-slate-500 tw-text-sm tw-text-center tw-items-center tw-justify-center tw-align-middle">
            Select {selectedFilter} to load attribute values
          </div>
        )}

      <div>
        <div className="tw-flex tw-items-center tw-mt-3">
          <div className="tw-w-[20%] tw-pe-2">
            <label className="tw-text-sm tw-text-[#747593] tw-block">
              {SELECTION_TYPE}
            </label>
            <select
              onChange={handleSelectTypeChange}
              value={fieldDataConfiguration?.selectType ?? ""}
              className="drop-down-dm"
            >
              <option value={''}>Select</option>
              {["Single-select", "Multi-select"].map((item, index) => {
                return (
                  <option value={item} key={item + index}>
                    {item}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="tw-w-[40%] tw-ms-4">
            <label className="tw-text-sm tw-text-[#747593] tw-block">
              {DEFAULT_VALUE}
            </label>
            <select
              className="drop-down-dm"
              value={fieldDataConfiguration.defaultValue ?? ""}
              onChange={handleDefaultTypeChange}
            >
              <option value={''}>Select Choice</option>
              {fieldDataConfiguration?.choices &&
                fieldDataConfiguration?.choices.length !== 0 &&
                fieldDataConfiguration?.choices.map((item, index) => {
                  return (
                    <option
                      value={item?.value ? item?.value : item?.av_value}
                      key={index}
                    >
                      {item?.display_value ?? item?.value ?? item?.av_value}
                    </option>
                  );
                })}
            </select>
          </div>
          <div className="tw-w-[10%] tw-ms-5">
            <label className="tw-text-sm tw-text-[#747593] tw-block tw-mb-1.5">
              {REQUIRED}
            </label>
            <ToggleButton
              name="Required"
              value={fieldDataConfiguration?.fieldRequired ?? false}
              onChange={(e) => handleRequiredChange(e.target.checked)}
            />
          </div>
          {isGuide ? <div className="tw-w-[20%]">
            <div className="tw-flex tw-items-center tw-gap-1 tw-mb-1.5">
              <label className="tw-text-sm tw-text-[#747593] tw-block">
                {PREDICTIVE_SORT}
              </label>
              {/*<OverlayIcon message={""} />*/}
            </div>
            <ToggleButton
              name="PredictiveSort"
              value={fieldDataConfiguration?.predictiveSort ?? false}
              onChange={(e) => handlePredictiveSortChange(e.target.checked)}
            />
          </div> : null}
        </div>
      </div>
      <ConfigurationFilterComponent
        id={`${id}-config-filter`}
        fieldDataConfiguration={fieldDataConfiguration}
        setFieldDataConfiguration={setFieldDataConfiguration}
        userProjectDataModels={userProjectDataModels}
        indexInfo={indexInfo}
      />

      <div className="tw-flex tw-items-center tw-gap-1 tw-mt-4">
        <ClassIcon />
        <label className="cart-title">{FIELD_CLASS}</label>
      </div>
      <div className="tw-flex tw-items-center tw-mt-1 tw-pb-3">
        <div className="tw-w-[30%] tw-pe-2">
          <select
            className={`drop-down-dm`}
            value={fieldDataConfiguration?.class?.name}
            onChange={handleClassChange}
          >
            <option>{SELECT_CLASS}</option>
            {isrContext?.fieldClasses?.map(
              (item: TFieldClass, index: number) => {
                return (
                  <option value={item?.name} key={item?.id ?? "" + index}>
                    {item?.name}
                  </option>
                );
              }
            )}
          </select>
        </div>
        <button
          onClick={openConnectorMenu}
          className="tw-w-auto tw-cursor-pointer tw-flex tw-items-center tw-gap-1 tw-ms-4"
        >
          <GearIcon />
          <label className="tw-text-sm tw-text-primary tw-block">
            {MANAGE}
          </label>
        </button>
      </div>
      <>
        <label className="cart-title tw-mt-2">{COUNT}</label>
        <div className="tw-flex tw-items-center tw-mt-2">
          <div className="tw-w-[20%] ">
            <label className="tw-text-sm tw-text-[#747593] tw-block">
              {MIN}
            </label>
            <input
              className="input-field-dm"
              type="number"
              value={fieldDataConfiguration?.minCount ?? 0}
              onChange={(e) =>
                handleMinMaxFields(Number(e.target.value), MIN_COUNT)
              }
              placeholder={ENTER}
            />
          </div>
          <div className="tw-w-[20%] tw-ms-5">
            <label className="tw-text-sm tw-text-[#747593] tw-block">
              {MAX}
            </label>
            <input
              className="input-field-dm"
              type="number"
              value={fieldDataConfiguration?.maxCount ?? 0}
              onChange={(e) =>
                handleMinMaxFields(Number(e.target.value), MAX_COUNT)
              }
              placeholder={ENTER}
            />
          </div>
        </div>
        <label className="cart-title tw-mt-2">{QUANTITY}</label>
        <div className="tw-flex tw-items-center tw-mt-2">
          <div className="tw-w-[20%] ">
            <label className="tw-text-sm tw-text-[#747593] tw-block">
              {MIN}
            </label>
            <input
              className="input-field-dm"
              type="number"
              value={fieldDataConfiguration?.minQuantity ?? 0}
              onChange={(e) =>
                handleMinMaxFields(Number(e.target.value), MIN_QUANTITY)
              }
              placeholder={ENTER}
            />
          </div>
          <div className="tw-w-[20%] tw-ms-5">
            <label className="tw-text-sm tw-text-[#747593] tw-block">
              {MAX}
            </label>
            <input
              className="input-field-dm"
              type="number"
              value={fieldDataConfiguration?.maxQuantity ?? 0}
              onChange={(e) =>
                handleMinMaxFields(Number(e.target.value), MAX_QUANTITY)
              }
              placeholder={ENTER}
            />
          </div>
        </div>
      </>

      {showClassMenu ? (
        <ManageClassDialog
          id={`${id}-manage-class-dialog`}
          showClassMenu={showClassMenu}
          setShowClassMenu={setShowClassMenu}
          projectId={projectId}
        />
      ) : null}

      {showImage && (
        // const overlayClasses = 'tw-abosulte tw-inset-0 tw-bg-black tw-opacity-50 tw-z-40 tw-h-full tw-w-full';
        <div className=" tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-z-40 tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center">
          <div className="tw-bg-white">
            <div className="tw-flex tw-justify-between">
              <div className="tw-mt-2 tw-ml-2 tw-font-bold"> {ITEM_IMAGE}</div>
              <div>
                <button
                  onClick={() => {
                    setShowImage(false);
                  }}
                  className="tw-mt-2 tw-mr-2 tw-h-8 tw-px-[22px] tw-py-2 tw-bg-white tw-rounded tw-border tw-border-blue-800 tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex"
                >
                  <span className="tw-text-center tw-text-blue-800 tw-text-sm tw-font-normal font-['Noto Sans'] leading-tight">
                    <XIcon />
                  </span>
                </button>
              </div>
            </div>
            <div className="tw-w-[613px] tw-h-[613px] tw-bg-white tw-rounded tw-shadow tw-border-neutral-300 tw-justify-center tw-align-middle tw-flex tw-p-2">
              {imageUrl ? (
                <img  src={imageUrl} alt="default-image" />
              ) : (
                <span>{NO_IMAGE_AVAILABLE}</span>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MultiChoiceConfigurations;
